var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.09375V4.25C16 3.2835 15.2165 2.5 14.25 2.5H1.75C0.7835 2.5 0 3.2835 0 4.25V5.09375C0 5.18003 0.0699688 5.25 0.15625 5.25H15.8438C15.93 5.25 16 5.18003 16 5.09375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.40625V11.75C0 12.7165 0.7835 13.5 1.75 13.5H14.25C15.2165 13.5 16 12.7165 16 11.75V6.40625C16 6.31997 15.93 6.25 15.8438 6.25H0.15625C0.0699688 6.25 0 6.31997 0 6.40625ZM4 10.5C4 10.7761 3.77612 11 3.5 11H3C2.72388 11 2.5 10.7761 2.5 10.5V10C2.5 9.72388 2.72388 9.5 3 9.5H3.5C3.77612 9.5 4 9.72388 4 10V10.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCard);
export default __webpack_public_path__ + "static/media/ic-card.628f0d4a12cedc9253213ee9fc63e2fb.svg";
export { ForwardRef as ReactComponent };